exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tbl[data-v-e845c3b2]{table-layout:fixed;width:100%!important}#tbl .col-sr[data-v-e845c3b2]{width:50px!important;text-align:center}#tbl .col-date[data-v-e845c3b2]{width:110px!important;white-space:nowrap}#tbl .col-question[data-v-e845c3b2]{width:auto!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e845c3b2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/school/LMS/CourseSkill.vue
// module id = 225
// module chunks = 0